module.exports = __webpack_public_path__ + "static/media/black_body.a3f4fac9.png";